import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__tips"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { style: {
              width: '100%',
              height: '700px',
              'border-radius': '2px',
              position: 'absolute',
              top: '0',
              left: '0',
              boxSizing: 'border-box',
              padding: '0 20px'
            } }
const _hoisted_5 = { class: "bi-tmpl-detail__right__cmpt__radioBox" }

import { BaseRadio } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import PcModuleOverview from '../bi-pc-module/pc-module-overview/index';

import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-3',
  setup(__props) {

const TYPE_MAPPING = [1, 2, 3, 4].map(i => {
  return {
    value: 'pc-module-overview-' + i,
    index: i
  };
});

const cmpName = name => {
  return PcModuleOverview.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange, titleCmpt, pageNoCmpt } = useDetailCmpt({});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 675,
      itemWidth: 420 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TYPE_MAPPING), (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", {
              class: "xrk-card",
              onClick: ($event: any) => (_unref(onChange)(item.value)),
              style: {"width":"420px","height":"700px"}
            }, [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(titleCmpt)), _mergeProps({
                  style: {"width":"1200px","transform":"scale(0.33)","transform-origin":"0 center"},
                  ref_for: true
                }, {
                innerText: '项目总览',
                enInnerText: 'Project Overview'
              }), null, 16)),
                (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(item.value)))),
                (_unref(pageNoCmpt))
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(pageNoCmpt)), {
                      key: 0,
                      style: {"width":"60px","height":"30px"}
                    }))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_3),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(BaseRadio), {
                value: item.value,
                "model-value": _unref(curItem).value,
                onClick: ($event: any) => (_unref(onChange)(item.value))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(), 1)
                ]),
                _: 2
              }, 1032, ["value", "model-value", "onClick"])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 512)
  ]))
}
}

})